<script>
  import { fade } from "svelte/transition"; 
  import SliderSplash from "../components/SliderSplash.svelte"; 

  import { session } from "../components/js/notif.js";

  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = []; 
</script> 
<main transition:fade class="container relative mx-auto lg:max-w-4xl">
  
  <SliderSplash />
  <div class="absolute bottom-0 left-0 right-0 z-10 flex flex-wrap items-center mx-auto mb-8">
    <div class="w-1/2 px-4 py-2 mx-auto lg:w-1/3 lg:px-2">
      <a 
        id="btnfilter-all" class="block px-4 py-3 text-gray-800 bg-gray-100 border-2 border-blue-400 rounded-full shadow-md cursor-pointer group hover:shadow-lg"
        href="/daftar">
        <div class="text-center">
          <h1 class="text-sm font-semibold group-hover:text-green-700">
            DAFTAR
          </h1>
        </div>
      </a>
    </div>

    <div class="w-1/2 px-4 py-2 mx-auto lg:w-1/3 lg:px-2">
      <a 
        id="btnfilter-accept" class="block px-4 py-3 text-gray-800 bg-gray-100 border-2 border-green-400 rounded-full shadow-md cursor-pointer group hover:shadow-lg"
        href="/login">
        <div class="text-center">
          <h1 class="text-sm font-semibold group-hover:text-green-700">
            MASUK 
          </h1>
        </div>
      </a>
    </div>
  </div>

</main>
